export const cdnAssetOptionsKeys = ['width', 'height', 'sequenceNumber'];
//# sourceMappingURL=cdn-asset-options.js.map